import logo from './logo.svg';
import './App.css';
import { useEffect } from "react";
import { loadGoogleAnalytics } from "./lib/analytics";
import WelcomePage from './components/WelcomePage';
import ReactGA from 'react-ga4';



function App() {
  
  ReactGA.initialize('G-J73Y5P4PRJ');
  ReactGA.send({ hitType: "pageview", page: window.location.pathname + window.location.search, title: "Study Buddy Home" });
  useEffect(() => {
    loadGoogleAnalytics();
  }, []);

  
  return (
    <div className="App">
        <WelcomePage/>  
    </div>
  );
}

export default App;
